import React from 'react';
import { IconProps } from './model/IconInterface';

const SortIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M8 9l4-5 4 5" /><path d="M8 15l4 5 4-5" />
    </svg>
  );
};

export default SortIcon;
